import * as tiff from "tiff";

export const tiffToCanvases = (data: ArrayBuffer): HTMLCanvasElement[] => {
  try {
    const ifd = tiff.decode(data);

    return ifd
      .map((ifd) => {
        const canvas = document.createElement("canvas");
        canvas.width = ifd.width;
        canvas.height = ifd.height;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          console.warn("Failed to get canvas context to render TIFF");
          return null;
        }

        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

        const bits = ifd.bitsPerSample;

        if (bits === 8) {
          imgData.data.set(ifd.data);
        } else {
          const bitDepth = 1 << bits;

          for (let i = 0; i < ifd.data.length; i += 4) {
            // maybe this will vectorize better with SIMD than i++?
            imgData.data[i] = ifd.data[i] / bitDepth;
            imgData.data[i + 1] = ifd.data[i + 1] / bitDepth;
            imgData.data[i + 2] = ifd.data[i + 2] / bitDepth;
            imgData.data[i + 3] = ifd.data[i + 3] / bitDepth;
          }
        }
        ctx.putImageData(imgData, 0, 0);

        return canvas;
      })
      .filter((canvas) => !!canvas) as HTMLCanvasElement[];
  } catch (err) {
    console.error(err);
    return [];
  }
};
